import { axios, axiosready } from '@/libs/api.request'

export const login = (data) => {
    return axios.request({
        url: 'auth/login',
        data,
        method: 'post'
    })
}

export const logout = (token) => {
    return axios.request({
        url: 'logout',
        method: 'post'
    })
}

export const getcode = (params) => {
  return axios.request({
    url: `admin/get_sms_code/${params.phone}`,
    method: 'get',
    params
  })
}
// 重置密码 版本v1
export const resetPwdBySmsCode = (params) => {
  return axios.request({
    url: `admin/reset_pwd_by_sms_code`,
    method: 'put',
    data: params
  })
}

export const getSmscode = () => {
  return axios.request({
    url: `admin/get_current_user_sms_code`,
    method: 'get'
  })
}

export const changePwd = (params) => {
    return axios.request({
      url: `/sys-user/change-password`,
      method: 'post',
      data: params
    })
  }

  export const changePwdByCode = (params) => {
    return axios.request({
      url: `/admin/reset_pwd_by_sms_code`,
      method: 'PUT',
      data: params
    })
  }

  export const changePwdBySmsCode = (params) => {
    return axios.request({
      url: `/admin/permission/changePwd`,
      method: 'PUT',
      data: params
    })
  }

export const getUnreadCount = () => {
    return axios.request({
        url: 'message/count',
        method: 'get'
    })
}

export const getMessage = () => {
    return axios.request({
        url: 'message/init',
        method: 'get'
    })
}

export const getContentByMsgId = msg_id => {
    return axios.request({
        url: 'message/content',
        method: 'get',
        params: {
            msg_id
        }
    })
}

export const hasRead = msg_id => {
    return axios.request({
        url: 'message/has_read',
        method: 'post',
        data: {
            msg_id
        }
    })
}

export const removeReaded = msg_id => {
    return axios.request({
        url: 'message/remove_readed',
        method: 'post',
        data: {
            msg_id
        }
    })
}

export const restoreTrash = msg_id => {
    return axios.request({
        url: 'message/restore',
        method: 'post',
        data: {
            msg_id
        }
    })
}
